import * as React from 'react';
import PropTypes from 'prop-types';
import { animated } from 'react-spring';
import { useAnimatedSteps } from '../hooks/use-steps';
export default function Appear(_ref) {
  var id = _ref.id,
      className = _ref.className,
      childrenOrRenderFunction = _ref.children,
      _ref$tagName = _ref.tagName,
      tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
      stepIndex = _ref.stepIndex,
      _ref$numSteps = _ref.numSteps,
      numSteps = _ref$numSteps === void 0 ? 1 : _ref$numSteps;

  if (numSteps !== 1 && typeof childrenOrRenderFunction !== 'function') {
    console.warn('TransitionElement seems to have multiple steps for no reason?');
  }

  var _useAnimatedSteps = useAnimatedSteps(numSteps, {
    id: id,
    stepIndex: stepIndex
  }),
      transitions = _useAnimatedSteps.transitions,
      isActive = _useAnimatedSteps.isActive,
      step = _useAnimatedSteps.step,
      placeholder = _useAnimatedSteps.placeholder;

  var AnimatedEl = animated[tagName];
  var children;

  if (typeof childrenOrRenderFunction === 'function') {
    children = childrenOrRenderFunction(step, isActive);
  } else {
    children = childrenOrRenderFunction;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, placeholder, transitions.map(function (_ref2) {
    var item = _ref2.item,
        props = _ref2.props,
        key = _ref2.key;
    return item && /*#__PURE__*/React.createElement(AnimatedEl, {
      key: key,
      style: props,
      className: className
    }, children);
  }));
}
Appear.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  tagName: PropTypes.string,
  stepIndex: PropTypes.number,
  numSteps: PropTypes.number
};